import { Component, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
@Component({
  selector: 'app-product-size-checker',
  imports: [MatCheckboxModule, FormsModule],
  templateUrl: './product-size-checker.html',
  styleUrl: './product-size-checker.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductSizeChecker),
      multi: true,
    },
  ],
})
export class ProductSizeChecker implements ControlValueAccessor {
  sizes: string[] = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  value: string[] = [];

  onCheckChanged(event: MouseEvent, size: string) {
    event.preventDefault();
    event.stopPropagation();
    if (this.value.includes(size)) {
      this.value.splice(this.value.indexOf(size), 1);
    } else {
      this.value.push(size);
    }
    this.onChange(this.value);
  }

  onChange: (value: string[]) => void = () => {};
  onTouched: () => void = () => {};
  writeValue(value: string[]): void {
    this.value = value || [];
  }

  registerOnChange(fn: (value: string[]) => void): void {
    this.onChange = fn; // 注册外部的变更回调
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn; // 注册外部的触摸回调
  }

  disabled: boolean = false;
  // 可选：禁用组件
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
